import * as React from "react";
import { ListItem } from "material-ui";
import {divider, hover} from "colors";

const BorderedListItem: React.SFC<any> = props => {
    return <ListItem style={{
        borderRadius: "0.125rem",
        border: "0.0625rem solid",
        borderColor: divider,
        background: hover,
        marginBottom: "0.3125rem"
    }} {...props}>
        {props.children}
    </ListItem>;
};

export default BorderedListItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/BorderedListItem/BorderedListItem.tsx